export const IndustryListData = [
  'General merchandise',
  'Medical',
  'Transportation',
  'Sporting goods',
  'Restaurant',
  'Cell Phones, PDAs, pagers',
  'Makeup and Cosmetics',
  'Fine jewelry and watches Retail',
  'Health and beauty spas',
  'Clothing',
  'Software',
  'Telecommunication services',
  'Travel Agency',
  'Others',
];
